import React, { useCallback, useEffect, useMemo, useState } from "react";
import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import DeleteModal from "../../Components/Common/DeleteModal";
import {
    Button,
    Card,
    CardHeader,
    Col,
    Container,
    Form,
    FormFeedback,
    Input,
    Label,
    Modal,
    ModalBody, ModalFooter,
    ModalHeader,
    Row, Spinner
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import Loader from "../../Components/Common/Loader";
import Flatpickr from "react-flatpickr";
import { toast, ToastContainer } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
    addNewBranch as onAddNewBranch,
    deleteBranch as onDeleteBranch,
    getBranches as onGetBranches,
    updateBranch as onUpdateBranch
} from "../../slices/branch/thunk";

import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import Appconfig from "../config/Appconfig";
import AuthorizeForAction from "../../Routes/AuthorizeForAction";

const Branch = () => {

    const dispatch = useDispatch();
    const [isEdit, setIsEdit] = useState(false);
    const [modal, setModal] = useState(false);
    const [branch, setBranch] = useState([]);
    const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
    const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteModalMulti, setDeleteModalMulti] = useState(false);
    const [lastdeletedtitle, setlastdeletedtitle] = useState("");


    const [loading, setLoading] = useState(true);
    const [isloading, setIsloading] = useState(false);




    const selectLayoutState = (state) => state.Branch;
    const branchProperties = createSelector(
        selectLayoutState,
        (data) => ({
            branches: data.branches,
            isBranchSuccess: data.isBranchSuccess,
            isBranchCreated: data.isBranchCreated,
            isBranchCreatedLoader: data.isBranchCreatedLoader,
            error: data.error,
        })
    );

    const {
        branches, isBranchSuccess, error, isBranchCreated, isBranchCreatedLoader
    } = useSelector(branchProperties)

    const toggle = useCallback(() => {
        if (modal) {
            setModal(false);

        } else {
            setModal(true);
        }
    }, [modal]);

    useEffect(() => {
        if (branches && !branches.length) {
            dispatch(onGetBranches());
        }
    }, [dispatch]);

    useEffect(() => {
        setBranch(branches);
        setLoading(!isBranchSuccess);
        if (isBranchCreated) {
            setIsloading(false);
            validation.resetForm();
            setModal(false);
        }
        error ? setIsloading(false) : null
    }, [branches, isBranchSuccess, isBranchCreated, error]);

    useEffect(() => {
        if (!isEmpty(branches)) {
            setBranch(branches);
            setIsEdit(false);
        }
    }, [branches, lastdeletedtitle]);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            title: (isEdit ? (branch && branch.title) : "") || '',
            status: (isEdit ? (branch && branch.status) : "") || '',
            exam_template: (isEdit ? (branch && branch.exam_template) : "") || '',
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Please Enter Title"),
            status: Yup.string().required("Please Enter Your Status"),
            exam_template: Yup.string().required("Require this field")
        }),
        onSubmit: (values) => {
            setIsloading(true);
            if (isEdit) {
                const updateBranch = {
                    id: branch ? branch.id : 0,
                    title: values.title,
                    status: values.status,
                    exam_template: values.exam_template
                };
                dispatch(onUpdateBranch(updateBranch));
            } else {
                const newBranch = {
                    title: values["title"],
                    status: values["status"],
                    exam_template: values['exam_template']
                };
                dispatch(onAddNewBranch(newBranch));
            }
        },
    });

    const statusList = [
        {
            options: [
                { label: "Select Status", value: " " },
                { label: "Active", value: "1" },
                { label: "In-Active", value: "2" },
            ],
        },
    ];

    const templateList = [
        {
            options: [
                { label: "Select Template", value: " " },
                { label: "RAK", value: "1" },
                { label: "Dubai", value: "2" },
            ],
        },
    ];

    const handleCustomerClick = useCallback((arg) => {
        const branch = arg;
        setBranch({
            id: branch.id,
            title: branch.title,
            status: branch.status,
            exam_template: branch.exam_template
        });
        setIsEdit(true);
        toggle();
    }, [toggle]);

    const checkedAll = useCallback(() => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        } else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
        deleteCheckbox();
    }, []);

    const deleteCheckbox = () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        ele.length > 0 ? setIsMultiDeleteButton(true) : setIsMultiDeleteButton(false);
        setSelectedCheckBoxDelete(ele);
    };

    const columns = useMemo(
        () => [
            {
                Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
                Cell: (cellProps) => {
                    return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id} onChange={() => deleteCheckbox()} />;
                },
                id: '#',

            },
            {
                Header: "Branch Title",
                accessor: "title",
                filterable: false,
            },


            {
                Header: "Exam Template",
                accessor: "exam_template",
                Cell: (cell) => {
                    if (cell.value == 1) {
                        return <span className="badge text-uppercase bg-success-subtle text-success">Rak</span>;
                    }
                    if (cell.value == 2) {
                        return <span className="badge text-uppercase bg-success-subtle text-success">Dubai</span>;
                    }


                }
            },

            {
                Header: "Status",
                accessor: "status",
                Cell: (cell) => {
                    switch (cell.value) {
                        case 1:
                            return <span className="badge text-uppercase bg-success-subtle text-success"> {cell.value == 1 ? "Active" : ""} </span>;
                        case 2:
                            return <span className="badge text-uppercase bg-danger-subtle text-danger"> {cell.value == 2 ? "In-Active" : ""} </span>;
                        default:
                            return <span className="badge text-uppercase bg-info-subtle text-info"> {cell.value == 2 ? "In-Active" : "Active"} </span>;
                    }
                }
            },
            {
                Header: "Action",
                Cell: (cellProps) => {
                    return (
                        <ul className="list-inline hstack gap-2 mb-0">
                            <AuthorizeForAction requiredPermissions={['branch-edit']}>
                                <li className="list-inline-item edit" title="Edit">
                                    <Link
                                        to="#"
                                        className="text-primary d-inline-block edit-item-btn"
                                        onClick={() => { const customerData = cellProps.row.original; handleCustomerClick(customerData); }}
                                    >
                                        <i className="ri-pencil-fill fs-16"></i>
                                    </Link>
                                </li>
                            </AuthorizeForAction>
                            <AuthorizeForAction requiredPermissions={['branch-delete']}>
                                <li className="list-inline-item" title="Remove">
                                    <Link
                                        to="#"
                                        className="text-danger d-inline-block remove-item-btn"
                                        onClick={() => { const customerData = cellProps.row.original; onClickDelete(customerData); }}
                                    >
                                        <i className="ri-delete-bin-5-fill fs-16"></i>
                                    </Link>
                                </li>
                            </AuthorizeForAction>
                        </ul>
                    );
                },
            },

        ],
        [handleCustomerClick, checkedAll]
    );
    const onClickDelete = (branch) => {
        setBranch(branch);
        setDeleteModal(true);
    };
    const deleteMultiple = () => {
        const checkall = document.getElementById("checkBoxAll");
        selectedCheckBoxDelete.forEach((element) => {
            dispatch(onDeleteBranch(element.value));
            setTimeout(() => { toast.clearWaitingQueue(); }, 3000);
        });
        setIsMultiDeleteButton(false);
        checkall.checked = false;
    };
    const handleCustomerClicks = () => {
        setBranch("");
        setIsEdit(false);
        toggle();
    };
    const handleDeleteCustomer = () => {
        if (branch) {
            dispatch(onDeleteBranch(branch.id));
            setDeleteModal(false);
        }
    };

    document.title = "Branches | Theory Practice";
    return (
        <React.Fragment>
            <div className="page-content">
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={handleDeleteCustomer}
                    onCloseClick={() => setDeleteModal(false)}
                />
                <DeleteModal
                    show={deleteModalMulti}
                    onDeleteClick={() => {
                        deleteMultiple();
                        setDeleteModalMulti(false);
                    }}
                    onCloseClick={() => setDeleteModalMulti(false)}
                />
                <Container fluid>
                    <BreadCrumb title="Branches List" pageTitle="Branch Management" />
                    <Row>
                        <Col lg={12}>
                            <Card id="customerList">
                                <CardHeader className="border-0">
                                    <Row className="g-4 align-items-center">
                                        <div className="col-sm">
                                            <div>
                                                <h5 className="card-title mb-0">Branches List</h5>
                                            </div>
                                        </div>
                                        <div className="col-sm-auto">
                                            <div>
                                                <AuthorizeForAction requiredPermissions={['branch-delete']}>
                                                    {isMultiDeleteButton && <button className="btn btn-soft-danger me-1"
                                                        onClick={() => setDeleteModalMulti(true)}
                                                    ><i className="ri-delete-bin-2-line"></i></button>}
                                                </AuthorizeForAction>
                                                <AuthorizeForAction requiredPermissions={['branch-create']} >
                                                    <button
                                                        type="button"
                                                        className="btn btn-success add-btn"
                                                        id="create-btn"
                                                        onClick={() => { setIsEdit(false); toggle(); }}>
                                                        <i className="ri-add-line align-bottom me-1"></i> Add
                                                        Branch
                                                    </button>{" "}
                                                </AuthorizeForAction>

                                            </div>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <div className="card-body pt-0">
                                    {(loading ?
                                        <React.Fragment>
                                            <div className="d-flex justify-content-center mx-2 mt-2">
                                                <Spinner color="primary"> Loading... </Spinner>
                                            </div>
                                            {/*{toast.error(props.error, { position: "top-right", hideProgressBar: false, progress: undefined, toastId: "" })}*/}
                                        </React.Fragment>
                                        : <div>
                                            {isBranchSuccess && branches.length ? (
                                                <TableContainer
                                                    columns={columns}
                                                    data={(branches || [])}
                                                    isGlobalFilter={true}
                                                    isAddUserList={false}
                                                    customPageSize={8}
                                                    className="custom-header-css"
                                                    handleCustomerClick={handleCustomerClicks}
                                                    isCustomerFilter={false}
                                                    SearchPlaceholder='Search for Branch, status or something...'
                                                />
                                            ) : (
                                                <div className="py-4 text-center">
                                                    <div>
                                                        <lord-icon
                                                            src="https://cdn.lordicon.com/msoeawqm.json"
                                                            trigger="loop"
                                                            colors="primary:#405189,secondary:#0ab39c"
                                                            style={{ width: "72px", height: "72px" }}
                                                        ></lord-icon>
                                                    </div>

                                                    <div className="mt-4">
                                                        <h5>Sorry! No Record Found</h5>
                                                    </div>
                                                </div>
                                            )}
                                        </div>)}
                                    <Modal id="showModal" backdrop="static" isOpen={modal} toggle={toggle} centered>
                                        <ModalHeader className="bg-light p-3" toggle={toggle}>

                                            {!!isEdit ? "Edit Branch" : "Add Branch"}

                                        </ModalHeader>
                                        <Form className="tablelist-form" onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}>
                                            <ModalBody>
                                                <input type="hidden" id="id-field" />

                                                <div
                                                    className="mb-3"
                                                    id="modal-id"
                                                    style={{ display: "none" }}
                                                >
                                                    <Label htmlFor="id-field1" className="form-label">

                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        id="id-field1"
                                                        className="form-control"
                                                        placeholder="ID"
                                                        readOnly
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <Label
                                                        htmlFor="title-field"
                                                        className="form-label"
                                                    >
                                                        Branch Title
                                                    </Label>
                                                    <Input
                                                        name="title"
                                                        id="name-field"
                                                        className="form-control"
                                                        placeholder="Enter Branch Title"
                                                        type="text"
                                                        validate={{
                                                            required: { value: true },
                                                        }}
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.title || ""}
                                                        invalid={
                                                            validation.touched.title && validation.errors.title ? true : false
                                                        }
                                                    />
                                                    {validation.touched.title && validation.errors.title ? (
                                                        <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="status-field" className="form-label">
                                                        Exam Template
                                                    </Label>
                                                    <Input
                                                        name="exam_template"
                                                        type="select"
                                                        className="form-select"
                                                        id="status-field"
                                                        onChange={validation.handleChange}
                                                        validate={{
                                                            required: { value: true },
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={
                                                            validation.values.exam_template || ""
                                                        }
                                                        invalid={
                                                            validation.touched.exam_template && validation.errors.exam_template ? true : false
                                                        }
                                                    >
                                                        {templateList.map((item, key) => (
                                                            <React.Fragment key={key}>
                                                                {item.options.map((item, key) => (<option value={item.value} key={key}>{item.label}</option>))}
                                                            </React.Fragment>
                                                        ))}

                                                    </Input>
                                                    {validation.touched.exam_template &&
                                                        validation.errors.status ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.exam_template}
                                                        </FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="status-field" className="form-label">
                                                        Status
                                                    </Label>
                                                    <Input
                                                        name="status"
                                                        type="select"
                                                        className="form-select"
                                                        id="status-field"
                                                        onChange={validation.handleChange}
                                                        validate={{
                                                            required: { value: true },
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={
                                                            validation.values.status || ""
                                                        }
                                                        invalid={
                                                            validation.touched.status && validation.errors.status ? true : false
                                                        }
                                                    >
                                                        {statusList.map((item, key) => (
                                                            <React.Fragment key={key}>
                                                                {item.options.map((item, key) => (<option value={item.value} key={key}>{item.label}</option>))}
                                                            </React.Fragment>
                                                        ))}

                                                    </Input>
                                                    {validation.touched.status &&
                                                        validation.errors.status ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.status}
                                                        </FormFeedback>
                                                    ) : null}
                                                </div>
                                            </ModalBody>
                                            <ModalFooter>

                                                <div className="hstack gap-2 justify-content-end">

                                                    <button type="button" className="btn btn-light" onClick={() => { setModal(false); validation.resetForm(); }}> Close </button>
                                                    <Button color="success" disabled={isloading ? true : false} className="btn-load" type="submit">
                                                        <span className="d-flex align-items-center">
                                                            {isloading ? <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner> : null}
                                                            <span className="flex-grow-1 ms-2">
                                                                {!!isEdit ? "Update" : "Add Branch"}{" "}
                                                            </span>
                                                        </span>
                                                    </Button>
                                                </div>
                                            </ModalFooter>
                                        </Form>
                                    </Modal>
                                    <ToastContainer closeButton={false} limit={1} />
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}
export default Branch;